import Assessments from '@app/src/components/Configurations/SustainabilityLibraryPages/Assessments/Assessments'
import CreateAssessmentFromQuestionnaire from '@app/src/components/Configurations/SustainabilityLibraryPages/Assessments/CreateAssessmentFromQuestionnaire'
import EditAssessment from '@app/src/components/Configurations/SustainabilityLibraryPages/Assessments/EditAssessment'
import { useBetterQueryParams } from '@app/src/hooks/queryParams'
import SustainabilityLibraryTags from '@app/src/pages/Configurations/ConfigurationsPages/SustainabilityLibraryTags/SustainabilityLibraryTags'
import QuestionConfig from '@app/src/pages/Configurations/SustainabilityLibraryPages/Questions/QuestionConfig'
import QuestionsConfig from '@app/src/pages/Configurations/SustainabilityLibraryPages/Questions/QuestionsConfig'
import { SUSTAINABILITY_LIBRARY_PAGE_IDS } from '@app/src/pages/Configurations/SustainabilityLibraryScene'
import React from 'react'
import CreateAutomation from './SustainabilityLibraryPages/Questionnaires/Flags/CreateAutomation'
import QuestionnaireConfig, {
  type QuestionnaireQueryParams,
} from './SustainabilityLibraryPages/Questionnaires/QuestionnaireConfig'
import QuestionnairesConfig from './SustainabilityLibraryPages/Questionnaires/QuestionnairesConfig'
import StandardQuestionnaireDetails from './SustainabilityLibraryPages/Questionnaires/StandardQuestionnaireDetails'

interface Props {
  content: SUSTAINABILITY_LIBRARY_PAGE_IDS
  configurationsSubPage?: string
  activeTabSubId?: string
  activeTabParam?: string
}

const SustainabilityLibraryContent: React.FC<Props> = ({
  content,
  configurationsSubPage,
  activeTabParam,
  activeTabSubId,
}) => {
  const { isStandard } = useBetterQueryParams<QuestionnaireQueryParams>()
  const isStandardQuestionnaire = String(isStandard) === 'true'

  switch (content) {
    case SUSTAINABILITY_LIBRARY_PAGE_IDS.Questionnaires:
      if (activeTabSubId) return <CreateAutomation requestItemTemplateId={activeTabSubId} />

      if (Number(configurationsSubPage)) {
        if (isStandardQuestionnaire && !activeTabParam) {
          return <StandardQuestionnaireDetails id={configurationsSubPage ?? ''} />
        }
        return <QuestionnaireConfig id={configurationsSubPage ?? ''} />
      }

      return <QuestionnairesConfig />

    case SUSTAINABILITY_LIBRARY_PAGE_IDS.Questions:
      return Number(configurationsSubPage) ? <QuestionConfig id={configurationsSubPage ?? ''} /> : <QuestionsConfig />

    case SUSTAINABILITY_LIBRARY_PAGE_IDS.Assessments:
      if (activeTabParam === 'edit') {
        return <EditAssessment assessmentId={Number(configurationsSubPage)} />
      }

      return Number(configurationsSubPage) ? (
        <CreateAssessmentFromQuestionnaire questionnaireTemplateId={Number(configurationsSubPage)} />
      ) : (
        <Assessments />
      )

    case SUSTAINABILITY_LIBRARY_PAGE_IDS.SustainabilityLibraryTags:
      return <SustainabilityLibraryTags />
  }
}

export default SustainabilityLibraryContent
